import { FilmFilterKey, FilterType, getFilterByIdAndType, getNumberOfFiltersApplied } from '@vista/omnichannel-components-domain';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { getFilterLabel } from '../../../utils/filters';
import { FilmListMessageType } from '../subcomponents/message';
export const useFilmListMessageProps = (filterConfig) => {
    const { config, displayText, i18n } = useOccContext();
    const filterId = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.filterId;
    if (!filterId)
        return { messageType: FilmListMessageType.NoFilms };
    const filter = getFilterByIdAndType(filterId, FilterType.Film);
    if (!filter)
        return { messageType: FilmListMessageType.NoFilms };
    const numberOfFiltersApplied = getNumberOfFiltersApplied({
        id: filterId,
        type: FilterType.Film,
        keys: Object.values(FilmFilterKey)
    });
    if (numberOfFiltersApplied === 0)
        return { messageType: FilmListMessageType.NoFilms };
    if (numberOfFiltersApplied === 1) {
        // Find the filter option that has been applied and grab its text.
        return {
            messageType: FilmListMessageType.NoFilmsForFilterOption,
            label: Object.entries(filter.sections).reduce((label, [key, section]) => {
                const selected = section.options.find(option => option.selected);
                return selected
                    ? getFilterLabel(key, selected.value, config, displayText, i18n)
                    : label;
            }, undefined)
        };
    }
    return {
        messageType: FilmListMessageType.NoFilmsForMultipleFilters
    };
};
